export default __webpack_public_path__ + "static/media/text.d41dc390.svg";